module.exports = __webpack_public_path__ + "img/wz-7-4-6.68810831.jpg";